import { Fragment, useState } from "react";
import { FormattedMessage } from "react-intl";

import { ReactComponent as Check } from "assets/images/iconsV2/check.svg";
import Button from "components/v2/Button/Button";
import Divider from "components/v2/Divider/Divider";
import Modal from "components/v2/Modal/Modal";
import { getNameAndEmailFromString } from "./ApprovalFlowHelpers";

type InvitedApproversModalProps = {
  show: boolean;
  onHide: () => void;
  requested_approvers: any;
};

function InvitedApproversModal({ show, onHide, requested_approvers }: InvitedApproversModalProps) {
  const [copiedIndex, setCopiedIndex] = useState<number>();

  const handleClickCopyEmail = (email: string, index: number) => {
    navigator.clipboard.writeText(email).then(() => {
      setCopiedIndex(index);
    });
  };

  const handleClose = () => {
    setCopiedIndex(undefined);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header showDivider>
        <div className="text-primary text-xl font-semibold">
          <FormattedMessage id="quote-request.approvalFlow.invitedApprovers" defaultMessage="Invited approvers" />
        </div>
      </Modal.Header>
      <Divider className="pt-xl" />
      <Modal.Body>
        <div className="pt-xl" style={{ maxHeight: "400px", overflowY: "auto" }}>
          {requested_approvers?.map((approver: string, index: number) => {
            const { name, email } = getNameAndEmailFromString(approver);
            return (
              <Fragment key={index}>
                <div className="py-md d-flex justify-content-between align-items-center">
                  <div>
                    <div className="font-medium text-md">{name}</div>
                    <div className="font-regular text-sm text-tertiary">{email}</div>
                  </div>
                  {copiedIndex === index ? (
                    <div className="d-flex align-items-center gap-sm font-semibold text-sm text-success-primary">
                      <Check width={20} height={20} stroke="#079455" />
                      <FormattedMessage id="general.copied" defaultMessage="Copied" />
                    </div>
                  ) : (
                    <Button
                      label={<FormattedMessage id="general.copyEmail" defaultMessage="Copy email" />}
                      variant="link-color"
                      onClick={() => handleClickCopyEmail(email, index)}
                    />
                  )}
                </div>

                <Divider />
              </Fragment>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
}

export default InvitedApproversModal;
